import "/app/app/styles.css?transform-only";export default "__VITE_CSS_URL__2f6170702f6170702f7374796c65732e6373733f7472616e73666f726d2d6f6e6c79__"